'use client';

import * as React from 'react';

type OverlayContextType = {
  refresh: () => void;
};

const OverlayContext = React.createContext<OverlayContextType | undefined>(undefined);

type OverlayProviderProps = {
  children: React.ReactNode;
  onRefresh?: () => void;
};

const OverlayProvider = ({ children, onRefresh }: OverlayProviderProps) => {
  const [, forceUpdate] = React.useReducer(x => x + 1, 0);

  const handleRefresh = () => {
    if (onRefresh) {
      onRefresh();
    } else {
      // Just update the state to trigger a re-render instead of full page reload
      forceUpdate();
    }
  };

  return (
    <OverlayContext.Provider value={{ refresh: handleRefresh }}>
      {children}
    </OverlayContext.Provider>
  );
};

const useOverlay = () => {
  const context = React.useContext(OverlayContext);
  if (context === undefined) {
    throw new Error('useOverlay must be used within an OverlayProvider');
  }
  return context;
};

export { OverlayProvider, useOverlay, OverlayContext };